import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "¿Trabajan con FEL/DTE (SAT)?",
    a: "Sí, todas nuestras soluciones están diseñadas para cumplir con los requisitos de Factura Electrónica en Línea (FEL) y Documentos Tributarios Electrónicos (DTE) de la SAT Guatemala.",
  },
  {
    q: "¿Pueden integrarse con mis sistemas actuales?",
    a: "Absolutamente. DocuWare se integra de forma nativa con sistemas ERP, CRM y otras plataformas empresariales. Nuestro equipo diseña la integración a medida para tu infraestructura.",
  },
  {
    q: "¿Incluyen capacitación y soporte?",
    a: "Sí, todos nuestros planes incluyen capacitación completa para tu equipo y soporte continuo. Nos aseguramos de que tu organización aproveche al máximo la plataforma.",
  },
  {
    q: "¿Qué hago si tengo más dudas?",
    a: "Escríbenos desde el formulario de contacto o a herberaldana@integradocgt.com. Te respondemos en 2–4 horas hábiles. Si es urgente, indica 'URGENTE' en el asunto.",
  },
];

const FAQ = () => (
  <section id="faq" className="py-24 section-gradient">
    <div className="container max-w-3xl">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="text-center mb-12"
      >
        <span className="text-sm font-semibold tracking-wider uppercase text-primary mb-3 block">
          FAQ
        </span>
        <h2 className="text-3xl sm:text-4xl font-bold text-foreground">
          Preguntas Frecuentes
        </h2>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ delay: 0.15 }}
      >
        <Accordion type="single" collapsible className="space-y-3">
          {faqs.map((faq, i) => (
            <AccordionItem
              key={i}
              value={`faq-${i}`}
              className="glass rounded-xl px-6 border-none"
            >
              <AccordionTrigger className="text-left font-semibold text-foreground hover:no-underline py-5">
                {faq.q}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground pb-5">
                {faq.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </motion.div>
    </div>
  </section>
);

export default FAQ;
